'use client'

import { useEffect } from 'react'
import { reportWebVitals } from '@/lib/web-vitals'

/**
 * Client component to initialize Core Web Vitals reporting
 * This component should be included in the root layout
 */
export default function WebVitalsReporter() {
  useEffect(() => {
    // Initialize web vitals reporting on mount
    reportWebVitals()
  }, [])

  // This component doesn't render anything
  return null
}